/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import Pagination from "../../../../../../widgets/pagination";
import MediaPrepTable from "../../../../../common/commonComponents/lotDetailsTableMediaPrep";
import { Container } from "../../../types/mediaBatchDispense.types";

interface Props {
	containers: Container[];
	page: number;
	setPage: (page: number) => void;
	totalPages: number;
	t: any;
	columns: any;
	containerError: string;
}

const ContainerTable = ({ containers, t, columns, page, setPage, totalPages, containerError }: Props) => {
 const handlePageChange = (page: number) => {
    setPage(page);
  };
	return (
		<div className="space-y-2 pt-2">
			<div className="flex items-center justify-between">
				<div className="flex items-center gap-4">
					<h4 className="text-[10px] font-black text-[#1E293B] uppercase tracking-[0.2em]">
						{t("mediaBatchInit.dispenseEntry.availableContainers")} (
						{containers.length})
					</h4>
					<div className="flex items-center gap-2 px-3 py-1 bg-slate-100 rounded-lg">
						<input type="checkbox" id="select-all" className="rounded" />
						<label
							htmlFor="select-all"
							className="text-[9px] font-black text-slate-500 uppercase tracking-widest cursor-pointer"
						>
							{t("mediaBatchInit.dispenseEntry.selectAll")}
						</label>
					</div>
				</div>
				<div className="flex items-center gap-4">
					<button className="flex items-center gap-2 text-[10px] font-black text-slate-400 uppercase tracking-widest hover:text-blue-500 transition-colors border-none rounded-2xl">
						<span className="material-symbols-outlined text-sm">
							download
						</span>
						{t("mediaBatchInit.dispenseEntry.export")}
					</button>
					<button className="flex items-center gap-2 text-[10px] font-black text-slate-400 uppercase tracking-widest hover:text-blue-500 transition-colors border-none rounded-2xl">
						<span className="material-symbols-outlined text-sm">
							refresh
						</span>
					</button>
				</div>
			</div>
			{containerError && (<p className="text-[11px] text-red-500">{containerError}</p>)}
			
				<div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-hidden">
					<MediaPrepTable
						columns={columns}
						data={containers}
						emptyMessage="No Plates available"
					/>
				{/* <Pagination
					page={page}
					totalPages={totalPages}
					handlePageChange={handlePageChange}
				/> */}
			    </div>
		</div>
	);
};
export default ContainerTable;
